import { computed, ref } from 'vue';
import CardsAPI from 'custom/dashboard/api/cards';

// The list view of a board: one paginated sequence across its stages, most recently changed
// first (?sort=recent), where the board fetches one column per stage.
export function useCardsList() {
  const cards = ref([]);
  const count = ref(0);
  const page = ref(0);
  const isLoading = ref(false);
  let request = 0;

  // Requests are numbered so a slow response for an outdated filter never lands last.
  const fetchPage = async (params, nextPage) => {
    request += 1;
    const current = request;
    isLoading.value = true;
    try {
      const { data } = await CardsAPI.get({
        ...params,
        sort: 'recent',
        page: nextPage,
      });
      if (current !== request) return;

      const loaded = nextPage === 1 ? [] : cards.value;
      const loadedIds = loaded.map(card => card.id);
      cards.value = [
        ...loaded,
        ...data.payload.filter(card => !loadedIds.includes(card.id)),
      ];
      count.value = data.meta.count;
      page.value = nextPage;
    } catch (error) {
      if (current === request) throw error;
    } finally {
      if (current === request) isLoading.value = false;
    }
  };

  const hasMore = computed(() => cards.value.length < count.value);

  return {
    cards,
    count,
    isLoading,
    hasMore,
    fetchList: params => fetchPage(params, 1),
    loadMore: params => fetchPage(params, page.value + 1),
  };
}
